// Observe all elements with aria-controls="mini-cart"
const miniCartTriggers = document.querySelectorAll('[aria-controls="mini-cart"]');

// BE-STABLE FIX: Items mit Produkttyp 'PPLR_HIDDEN_PRODUCT' ausblenden (sprach-/waehrungsunabhaengig).
// Loest die alte 'Kostenlos'-Text-Match-Logik ab, die nur auf Deutsch funktionierte.
function hide_free_items() {
  document.querySelectorAll('line-item').forEach(item => {
    if (item.classList.contains('pplr_hide')) return;

    const productType = item.getAttribute('data-product-type');
    if (productType === 'PPLR_HIDDEN_PRODUCT') {
      item.classList.add('pplr_hide');
    }
  });
}

// Watch for attribute changes (aria-expanded changes dynamically)
miniCartTriggers.forEach(trigger => {
  const observer = new MutationObserver(() => {
    if (trigger.getAttribute('aria-expanded') === 'true') {
      setTimeout(() => {
        hide_free_items();
      }, 80);
    }
  });

  observer.observe(trigger, { attributes: true, attributeFilter: ['aria-expanded'] });
});

// BE-STABLE: Auch bei cart:updated nochmal pruefen, falls Mengen geaendert wurden waehrend Drawer offen ist
document.addEventListener('cart:updated', function() {
  setTimeout(hide_free_items, 120);
});

window.addEventListener('pplrAddToCartCompleted', function(e) {
  // Run pplr_w_h only if the function exists (safety check)
  if (typeof pplr_w_h === 'function') pplr_w_h();
  
  // Refresh cart and handle conversion
  refreshCart();
});

async function refreshCart() {
  try {
    const response = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
    const cartContent = await response.json();
    
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cartContent }
    }));
    
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { 
        cart: cartContent,
        openMiniCart: false
      }
    }));
    
    // FIX: Wartezeit von 450ms auf 600ms erhoet - gibt dem DOM mehr Zeit zum Rendern
    setTimeout(() => {
      convertAllLineItemsAndOpenCart();
    }, 600);
    
  } catch (error) {
    console.error('Error refreshing cart:', error);
  }
}

function convertAllLineItemsAndOpenCart() {
  let attempts = 0;
  // FIX: maxAttempts von 5 auf 8 erhoet fuer langsamere Geraete
  const maxAttempts = 8;
  
  // FIX: Intervall von 450ms auf 300ms reduziert - schnellere Wiederholung bei mehr Versuchen
  const conversionInterval = setInterval(() => {
    attempts++;
    const convertedCount = convertLineItemsToPPLR();
    
    const allConverted = document.querySelectorAll('line-item:not(.pplr_cart_row)').length === 0;
    
    if (allConverted || attempts >= maxAttempts) {
      clearInterval(conversionInterval);
      openCartDrawer();
    }
  }, 300);
}

function openCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.setAttribute('open', '');
  } else {
    const cartBtn = document.querySelector('.pplr_to_cart, [aria-controls="mini-cart"]');
    if (cartBtn) cartBtn.click();
  }
}

function convertLineItemsToPPLR() {
  const lineItems = document.querySelectorAll('line-item:not(.pplr_cart_row)');
  let convertedCount = 0;
  
  lineItems.forEach((lineItem, index) => {
    if (convertSingleLineItem(lineItem, index + 1)) {
      convertedCount++;
    }
  });
  
  return convertedCount;
}

function convertSingleLineItem(lineItem, rowNumber) {
  lineItem.classList.add('pplr_cart_row');
  lineItem.setAttribute('data_pplr_row', rowNumber.toString());
  
  const propertyList = lineItem.querySelector('.product-item-meta__property-list');
  if (!propertyList) return false;
  
  const propertyItems = propertyList.querySelectorAll('li');
  if (propertyItems.length === 0) return false;
  
  let previewUrl = null;
  const properties = [];
  
  propertyItems.forEach(li => {
    const text = li.textContent.trim();
    const previewMatch = text.match(/Vorschau:\s*(https?:\/\/[^\s]+)/);
    if (previewMatch && previewMatch[1]) {
      previewUrl = previewMatch[1];
    } else {
      properties.push(text);
    }
  });
  
  if (previewUrl) {
    const previewUrl400x = previewUrl.replace('.png', '_400x.png');
    
    const img = lineItem.querySelector('.line-item__image');
    if (img) {
      img.src = previewUrl400x;
      img.removeAttribute('srcset');
    }
    
    propertyList.style.display = 'none';
    
    const existingPPLR = lineItem.querySelector('.pplr_properties');
    if (existingPPLR) existingPPLR.remove();
    
    const pplrProperties = document.createElement('span');
    pplrProperties.className = 'pplr_properties';
    pplrProperties.setAttribute('data-line', (rowNumber - 1).toString());
    
    let propertiesHTML = properties.map(prop => {
      const propMatch = prop.match(/([^:]+):\s*(.+)/);
      if (propMatch && propMatch[1] && propMatch[2]) {
        return `
          <span class="pplr_item_prop" style="width:100%;float:left">
            <span pplr_item_prop_name="">${propMatch[1].trim()}</span>: 
            <span pplr_item_prop_value="">${propMatch[2].trim()}</span>
          </span>
        `;
      } else {
        return `
          <span class="pplr_item_prop" style="width:100%;float:left">
            <span pplr_item_prop_value="">${prop}</span>
          </span>
        `;
      }
    }).join('');
    
    propertiesHTML += `
      <span class="pplr_item_prop" style="width:100%;float:left">
        <span pplr_item_prop_name="">Vorschau</span>: 
        <span pplr_item_prop_value="">
          <a class="pplr_slide" href="${previewUrl}">Vorschau</a>
        </span>
      </span>
    `;
    
    pplrProperties.innerHTML = propertiesHTML;
    propertyList.parentNode.insertBefore(pplrProperties, propertyList.nextSibling);
    
    const priceElement = lineItem.querySelector('.line-item__price-list-container .price, .product-item-meta__price-list-container .price');
    if (priceElement) {
      priceElement.classList.add('a_pplr_item_price');
      priceElement.setAttribute('data-line', (rowNumber - 1).toString());
    }
    
    const form = document.querySelector('#mini-cart-form');
    if (form && !form.classList.contains('pplr_cart_form_0')) {
      form.classList.add('pplr_cart_form_0');
    }
    
    return true;
  }
  
  return false;
}
